import Vue from 'vue'
import getYear from 'date-fns/get_year'
import { getField, updateField } from 'vuex-map-fields';

state =
    in_collection: 1 # whether the item is in our collection
    seen: 1 # whether we have seen the item
    reviewed: 1 # whether we have reviewed the item (left text)
    released: 1 # whether the item has been seen on predb
    hidden: 0 # whether to show movies that we have hidden

    genres: {} # map of id to genre
    countries: {} # map of id to country
    languages: {} # map of id to language
    streamers: {} # map of id to streamer

    range:
        imdb_score:
            description: 'The score on IMDb'
            lower_bound: 1
            min: 6.5
            max: 10
            step: 0.1
            upper_bound: 10
        imdb_votes:
            description: 'The number of votes on IMDb'
            lower_bound: 0
            min: 500
            max: 10 * 1000 * 1000
            step: 1
            upper_bound: 10 * 1000 * 1000 # XXX Upper bound should be dynamic
        metacritic_score:
            description: 'The score on Metacritic'
            lower_bound: 1
            min: 1
            max: 10
            step: 0.1
            upper_bound: 10
        year:
            description: 'The year of release'
            lower_bound: 1900
            min: 1900
            max: getYear(new Date())
            step: 1
            upper_bound: getYear(new Date())
        runtime:
            description: 'The length in minutes'
            lower_bound: 0
            min: 0
            max: 600
            step: 1
            upper_bound: 600
        imdb_last_check_time:
            description: 'How long ago the movie or episode was checked on IMDb'
            lower_bound: 0
            min: 0
            max: 600
            step: 1
            upper_bound: 600

    genre_icons:
        'Action': ['fas', 'crosshairs']
        'Adult': ['fas', 'mars']
        'Adventure': ['fas', 'bolt']
        'Animation': ['fas', 'palette']
        'Biography': ['fas', 'book']
        'Comedy': ['far', 'laugh-beam']
        'Crime': ['fas', 'user-secret']
        'Documentary': ['fas', 'graduation-cap']
        'Drama': ['far', 'gem']
        'Family': ['fas', 'users']
        'Fantasy': ['fas', 'wand-magic']
        'Film-Noir': ['fas', 'mask']
        'Game-Show': ['fas', 'trophy']
        'History': ['fas', 'landmark']
        'Horror': ['fas', 'ghost']
        'Music': ['fas', 'headphones']
        'Musical': ['fas', 'music']
        'Mystery': ['fas', 'crow']
        'News': ['fas', 'list']
        'Reality-TV': ['fas', 'home']
        'Romance': ['far', 'heart']
        'Sci-Fi': ['fas', 'rocket']
        'Short': ['fas', 'cut']
        'Sport': ['far', 'futbol']
        'Talk-Show': ['far', 'comments']
        'Thriller': ['fas', 'bomb']
        'War': ['fas', 'fighter-jet']
        'Western': ['fas', 'horse-head']

    genre_icons_by_id: {}

getters = { getField }

mutations = {
    # mutations for the simple fields (like 'seen')
    updateField

    # mutations for genres, countries and languages
    SET_GENRES: (state, genres) ->
        for id, item of genres
            Vue.set state.genres, id,
                'id': parseInt(id)
                'name': item
                'filter': 1
                'total': Math.round(Math.random() * 500)
                'visible': Math.round(Math.random() * 500) # XXX implement
            Vue.set state.genre_icons_by_id, id, state.genre_icons[item]
    SET_COUNTRIES: (state, countries) ->
        for id, item of countries
            Vue.set state.countries, id,
                'id': parseInt(id)
                'name': item
                'filter': 1
                'total': Math.round(Math.random() * 500)
                'visible': Math.round(Math.random() * 500)
    SET_LANGUAGES: (state, languages) ->
        for id, item of languages
            Vue.set state.languages, id,
                'id': parseInt(id)
                'name': item
                'filter': 1
                'total': Math.round(Math.random() * 500)
                'visible': Math.round(Math.random() * 500)
    SET_STREAMERS: (state, streamers) ->
        for id, item of streamers
            Vue.set state.streamers, id,
                'id': parseInt(id)
                'name': item
                'filter': 1
    SET_FILTER: (state, { item_list_name, item_id, filter_state }) ->
        Vue.set state[item_list_name][item_id], 'filter', filter_state
    RESET_FILTER: (state, item_list_name) ->
        for id, item of state[item_list_name]
            Vue.set item, 'filter', 1

    # mutations for the ranges
    SET_RANGE: (state, { name, min, max }) ->
        Vue.set state.range[name], 'min', min
        Vue.set state.range[name], 'max', max
}

export default {
    namespaced: true
    state
    getters
    mutations
}
